// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function CultivationDiaryTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Cultivation Diary</p>
      <p>
        A living diary for every crop — timeline activity from Arca tools, notes, photos, and an AI
        scorecard, all in one place per grow.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Start a crop in Crops (or from a cultivation target schema).</li>
          <li>Open its card here to view the full timeline, metrics, and scorecard.</li>
          <li>Log entries, photos, and voice notes as the grow progresses.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">What appears in the diary</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Runoff, fertility, and spray events logged in Arca</li>
          <li>Stage progression tied to your target schema</li>
          <li>Search and filter across active and completed crops</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        The diary auto-assembles activity — consistent logging in other Arca tools keeps the timeline complete.
      </p>
    </div>
  );
}
